<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col>
        HTTP 메소드 제어

        <c-switch color="info" class="float-right" label variant="pill" size="sm" defaultChecked v-model="use_method" @change="change_use_method"/>
      </b-col>
    </b-row>
    <hr>
    <b-row class="mb-3">
      <b-col sm="3">
        메소드
      </b-col>
      <b-col sm="4" class="text-left">
        IP Address(한 행에 한개씩)
        <br>
        <small class="text-danger">IP를 지정하지 않으면 지정된 가상 도메인에 적용됩니다</small>
        <small class="text-danger">아이피를 설정하면 해당 아이피에만 적용됩니다</small>
      </b-col>
      <b-col sm="2" class="text-left">
        차단 모드
      </b-col>
      <b-col sm="3">
        방화벽 모드에 따라 동작
      </b-col>
    </b-row>
    <hr>
    <b-row class="mb-3" v-for="(m, index) in method_list" :key="'_method_'+index">
      <b-col class="text-left" sm="3" :style="use_method ? '' : 'text-decoration: line-through;'">
        {{ m.method.toUpperCase() }} 요청을
        <span v-if="m.is_mode">
          <b-badge v-if="now_mode == 0" variant="secondary">미사용</b-badge>
          <b-badge v-if="now_mode == 1" variant="warning">탐지</b-badge>
          <b-badge v-if="now_mode == 2" variant="danger">차단</b-badge>
        </span>
        <span v-else>
          <b-badge v-if="m.is_block" variant="danger">차단</b-badge>
          <b-badge v-else variant="warning">탐지</b-badge>
        </span>
        합니다
      </b-col>
      <b-col sm="4" class="text-left" v-if="m">
        <b-form-textarea :disabled="!use_method" @update="update($event, m.method, 'ip_list')" id="ph_content" v-model="m.ip_list" :max-rows="50"></b-form-textarea>
      </b-col>
      <b-col sm="2" class="text-left" v-if="m">
        <c-switch :disabled="m.is_mode || !use_method" color="danger" label variant="pill" size="sm" defaultChecked v-model="m.is_block" @change="update($event, m.method, 'is_block')"/>
      </b-col>
      <b-col sm="3" v-if="m">
        <c-switch :disabled="!use_method" color="primary" label variant="pill" size="sm" defaultChecked v-model="m.is_mode" @change="update($event, m.method, 'is_mode')"/>
      </b-col>
    </b-row>
    <hr>
    <!-- 설명 모달 영역 -->
    <b-modal title="Block Base Country Code"  class="modal-info" v-model="explain_modal" ok-variant="success" header-bg-variant="success" ok-only>
      <!-- <p>For country code blocking, you must use the GEO-IP function to convert IP to country</p>
      <p>123.123.123.123 	&rArr; KR  </p> -->
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
